import { createSlice } from '@reduxjs/toolkit'

export const loginSlice = createSlice({
  name: 'isLogged',
  initialState: {
    value: false,
  },
  reducers: {
    loggedin: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes.
      // Also, no return statement is required from these functions.
      state.value = true
    },
    loggedoutt: (state) => {
      state.value = false
    },
  },
})

// Action creators are generated for each case reducer function
export const { loggedin, loggedoutt } = loginSlice.actions

export default loginSlice.reducer